import React, { useState } from 'react';
import { FileText, Table as TableIcon } from '@phosphor-icons/react';
import { Button } from '../components/ui/button';
import AuditFilters from './audit/AuditFilters';
import AuditLogDetailDialog from './audit/AuditLogDetailDialog';
import AuditLogTable from './audit/AuditLogTable';
import AuditSummaryCards from './audit/AuditSummaryCards';
import { useAuditLogs } from './audit/useAuditLogs';

/**
 * Admin Audit Log page — composed of 4 dumb children driven by the
 * `useAuditLogs` hook. The page itself owns only the detail-modal selection.
 */
const AuditLogPage = () => {
  const audit = useAuditLogs();
  const [selectedLog, setSelectedLog] = useState(null);
  const [detailOpen, setDetailOpen] = useState(false);

  const viewLogDetail = (log) => {
    setSelectedLog(log);
    setDetailOpen(true);
  };

  return (
    <div className="space-y-6 animate-fade-in" data-testid="audit-log-page">
      <div className="flex justify-between items-start">
        <div>
          <h1 className="text-3xl font-bold text-slate-900" style={{ fontFamily: 'Manrope' }}>
            Audit Logs
          </h1>
          <p className="text-slate-500 mt-1">
            Track all user activity and system events for compliance
          </p>
        </div>
        <div className="flex gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => audit.exportLogs('csv')}
            data-testid="export-csv-btn"
          >
            <FileText size={16} className="mr-1" />
            CSV
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={() => audit.exportLogs('xlsx')}
            data-testid="export-xlsx-btn"
          >
            <TableIcon size={16} className="mr-1" />
            Excel
          </Button>
        </div>
      </div>

      <AuditSummaryCards summary={audit.summary} />

      <AuditFilters
        filters={audit.filters}
        loading={audit.loading}
        datePreset={audit.datePreset}
        setDatePreset={audit.setDatePreset}
        selectedAction={audit.selectedAction}
        setSelectedAction={audit.setSelectedAction}
        selectedResource={audit.selectedResource}
        setSelectedResource={audit.setSelectedResource}
        selectedSeverity={audit.selectedSeverity}
        setSelectedSeverity={audit.setSelectedSeverity}
        searchTerm={audit.searchTerm}
        setSearchTerm={audit.setSearchTerm}
        onSearch={audit.handleSearch}
        onRefresh={audit.handleRefresh}
      />

      <AuditLogTable
        logs={audit.logs}
        total={audit.total}
        loading={audit.loading}
        page={audit.page}
        totalPages={audit.totalPages}
        onPageChange={audit.setPage}
        onViewDetail={viewLogDetail}
      />

      <AuditLogDetailDialog open={detailOpen} onOpenChange={setDetailOpen} log={selectedLog} />
    </div>
  );
};

export default AuditLogPage;
